import { Text } from '@belong/ui';
import {
  MaintenanceQuoteCostItemConsumerModel,
  MaintenanceQuoteCostItemType,
} from 'maintenance/types/quote-centric';
import { splitCamelCase } from 'maintenance/utils/format';

const CATEGORY_ORDER = ['Labor', 'Parts', 'Other'] as const;
type CostCategory = (typeof CATEGORY_ORDER)[number];

// Partial: types without an entry (e.g. Discount, ProjectCoordination) are not
// part of the itemized work list — they're surfaced separately (or not at all,
// for the Project Management Fee), so they're skipped here.
const TYPE_TO_CATEGORY: Partial<
  Record<MaintenanceQuoteCostItemType, CostCategory>
> = {
  Labor: 'Labor',
  Parts: 'Parts',
  Other: 'Other',
  VendorFee: 'Other',
  Procurement: 'Other',
  Dispatch: 'Other',
  WasteDisposal: 'Other',
  BelongMargin: 'Other',
};

type CostItemsGroupProps = {
  costItems: MaintenanceQuoteCostItemConsumerModel[];
};

export const CostItemsGroup = ({ costItems }: CostItemsGroupProps) => {
  const grouped: Record<CostCategory, MaintenanceQuoteCostItemConsumerModel[]> =
    {
      Labor: [],
      Parts: [],
      Other: [],
    };

  for (const item of costItems) {
    const category = TYPE_TO_CATEGORY[item.type];
    if (!category) continue;
    grouped[category].push(item);
  }

  const categories = CATEGORY_ORDER.filter((cat) => grouped[cat].length > 0);

  return (
    <div className="flex flex-col gap-sm">
      {categories.map((category) => (
        <div key={category}>
          <Text fontWeight="semibold">{category}</Text>
          {grouped[category].map((item) => (
            <div key={item.uniqueId} className="ml-lg mt-xs">
              <Text>{item.description || splitCamelCase(item.type)}</Text>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
